<template>
  <ModalBase show-modal @close-modal="close" :overlay-scrollb="false" full-h class="invoice-design-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('EDIT') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice design') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <EditDesign
        ref="edit-invoice-design"
        :invoice="invoice"
        :totals="totals"
        :recipient="recipient"
        on-modal
        @close="close"
      />
    </template>
    <template v-slot:actions>
      <div style="display: flex; justify-content: space-between; gap: 0.5rem;">
        <GekkoButton 
          @click="close()"
          :text="$gettext('Close')"
          variant="light"
        />
        <GekkoButton 
          @click="saveChanges()"
          :text="$gettext('Save changes')"
          icon="fa-solid fa-floppy-disk"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import EditDesign from "@/components/invoices/EditDesign"

export default {
  name: "InvoiceDesignModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
    EditDesign
  },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    totals: {
      type: Object,
      default: () => {}
    },
    recipient: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    saveChanges () {
      this.$refs['edit-invoice-design'].saveChanges()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.invoice-design-modal {
  font-size: 1rem;
  .gk-modal {
    .modal-content-wrap { 
      position: relative; 
      margin: -1rem;
      margin-bottom: 0;
      border-bottom: 1px solid $colorBorderDash;
      .os-host-overflow-y { padding-right: 0 !important; }
    }
  }
}
</style>